<template>
	<footer>
		<div class="footer--inner">
			<ul>
				<li><a href="https://www.werberat.at/beschwerdeverfahrensordnung.aspx" title="Verfahrensordnung" target="_blank">Verfahrensordnung</a></li>
				<li><a href="https://www.werberat.at/ethikkodex.aspx" title="Ethik-Kodex" target="_blank">Ethik-Kodex</a></li>
				<li>
					<RouterLink to="/datenschutz" title="Unsere Datenschutzbestimmungen">Datenschutz</RouterLink>
				</li>
				<li>
					<RouterLink to="/impressum" title="Impressum">Impressum</RouterLink>
				</li>
				<li class="footer-social">
					<a href="https://at.linkedin.com/company/%C3%B6sterreichischer-werberat" title="Zu Linkedin" target="_blank">
						<linkedinIcon />
					</a>
				</li>
				<li class="footer-social">
					<a :href="`mailto:${texts.werberat.mail}`" :title="`Mail an ${texts.werberat.companyname}`">
						<el-icon><Message /></el-icon>
					</a>
				</li>
			</ul>

			<div class="footer--right">
				<ul>
					<li class="footer-social">
						<a href="https://at.linkedin.com/company/%C3%B6sterreichischer-werberat" title="Zu Linkedin" target="_blank">
							<linkedinIcon />
						</a>
					</li>
					<li class="footer-social">
						<a :href="`mailto:${texts.werberat.mail}`" :title="`Mail an ${texts.werberat.companyname}`">
							<el-icon><Message /></el-icon>
						</a>
					</li>
				</ul>

				<span class="footer-copyright">© {{ texts.werberat.companyname }} {{ currentYear }} - v{{ version }}</span>
			</div>
		</div>
	</footer>
</template>

<script lang="ts">
import linkedinIcon from '../assets/icons/linkedinIcon.vue';
import { Message } from '@element-plus/icons-vue';
import { texts } from '../utils/texts';
import { version } from '../../package.json';

export default {
	name: 'TheFooter',
	data() {
		return {
			version,
		};
	},
	computed: {
		currentYear() {
			return new Date().getFullYear();
		},
		texts() {
			return texts;
		},
	},
	components: {
		linkedinIcon,
		Message,
	},
};
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;

footer {
	display: inline-block;
	width: 100%;
	padding: 1.5rem 2rem;
	background-color: var(--el-color-primary);
	color: #fff;
	font-size: 0.9rem;
	box-sizing: border-box;

	.footer--inner {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		width: 100%;
		max-width: $content_maxwidth;
		margin: 0 auto;
	}

	ul {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		list-style: none;
		margin: 0;
		padding: 0;

		li {
			padding-right: 1rem;
			a {
				color: #fff;
				white-space: pre;
				&:after {
					border-color: #fff;
				}
			}
		}
	}

	.footer--right {
		display: flex;
		align-items: center;

		.footer-social {
			display: none;
		}
	}
}

/* mobile style */
@media screen and (max-width: $mobile_maxwidth) {
	footer {
		line-height: 1.6rem;
		.footer--inner {
			justify-content: center;
		}

		ul {
			width: 100%;
			justify-content: center;
			.footer-social {
				display: none;
			}
		}

		.footer--right {
			flex-direction: column;
			width: 100%;
			max-width: 400px;
			margin-top: 1.5rem;

			ul,
			.footer-copyright {
				width: 100%;
				display: flex;
				justify-content: center;
			}

			.footer-copyright {
				margin-top: 1rem;
			}

			.footer-social {
				display: flex;
				padding-right: 1.5rem;

				&:last-child {
					padding-right: 0;
				}
			}
		}
	}
}
</style>
